import { Module } from 'wrapper6'

const $ = jQuery

export default class MendelayArchive extends Module {
  ready (app) {
    this.loader = $('#loader')
    this.container = $('.mtt-mendelay-archive')
    this.destination = this.container.find('.mtt-mendelay-archive__wrapper')
    this.pagination = '.mtt-mendelay-archive .pagination li a'
    this.letters = '.mtt-mendelay-filter__letter'
    this.paginationDestination = this.container.find('.pagination')
    this.search = $('#mendelay-archive-search')

    // values
    this.pageNumber = 0

    this.addAlphabetClick()
    this.addSearch()
    this.addPagination()
  }

  addAlphabetClick () {
    $(document).on('click', this.letters, (e) => {
      e.preventDefault()
      this.setActiveLetter(e.target)
      this.pageNumber = 0

      this.getPapers()
    })
  }

  addSearch () {
    let globalTimeout = null
    this.search.on('input', (e) => {
      e.preventDefault()

      if (globalTimeout != null) clearTimeout(globalTimeout)

      globalTimeout = setTimeout(() => {
        this.setActiveLetter(document.querySelector('.mtt-mendelay-filter__letter.reset'))
        this.pageNumber = 0

        this.getPapers()
      }, 500)
    })
  }

  setActiveLetter (element) {
    if (document.querySelector('.mtt-mendelay-filter__alphabet li.active')) {
      document.querySelector('.mtt-mendelay-filter__alphabet li.active').classList.remove('active')
    }
    if (document.querySelector('.mtt-mendelay-filter__letter.reset.active')) {
      document.querySelector('.mtt-mendelay-filter__letter.reset').classList.remove('active')
    }
    element.classList.add('active')
  }

  addPagination () {
    $(document).on('click', this.pagination, (e) => {
      e.preventDefault()

      this.pageNumber = e.target.getAttribute('data-page')

      this.getPapers()
    })
  }

  getPapers () {
    this.loader.addClass('show')

    const data = {
      action: 'get_archive_papers',
      currentLetter: document.querySelector('.mtt-mendelay-filter__alphabet li.active') ? document.querySelector('.mtt-mendelay-filter__alphabet li.active').innerHTML : '',
      searchValue: this.search.val(),
      pageNumber: this.pageNumber,
      site: window.location.href
    }

    console.log(data)

    $.post(main_theme_objects.ajax_url, data, (response) => {
      if (response.markup !== '') {
        this.destination.html(response.markup)
      } else {
        this.destination.html('No papers or references found')
      }

      if (response.pagination !== '') {
        this.paginationDestination.html(response.pagination)
      } else {
        this.paginationDestination.html('')
      }

      this.loader.removeClass('show')
    })
  }
}
